import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { lightTheme as dsLightTheme } from '@gojitsu/web-ui-core';

// The @gojitsu/web-ui-core design-system lightTheme is the default and wins on
// any overlapping key. The app-specific values below are merged in only to
// supply extra keys the design system does not define (e.g. palette.jitsu,
// palette.tableHead, the MuiTableCell override) — they cannot override the DS.
// eslint-disable-next-line import/prefer-default-export
export const lightTheme = createTheme(
  deepmerge(
    {
      components: {
        // These were previously injected globally via the legacy @mui/styles
        // `makeStyles(styles, { name: "MuiTableCell" })` trick (the generated
        // `.MuiTableCell-root`/`-head` matched MUI's real classes). tss-react does
        // not replicate that, so the equivalent is theme styleOverrides — global.
        MuiTableCell: {
          styleOverrides: {
            root: {
              fontWeight: 500,
              fontStretch: 'normal',
              lineHeight: 'normal',
              letterSpacing: 'normal',
              fontStyle: 'normal',
              borderBottom: '1px solid #e0e0eb',
              padding: '10px 15px',
            },
            head: {
              color: '#bebfc0',
              textTransform: 'uppercase',
            },
          },
        },
        MuiButton: {
          defaultProps: {
            disableElevation: true
          }
        }
      },
    },
    dsLightTheme,
  ),
);
